import { HotkeyGeneratedEvent } from '@polaris/core/signing'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { hotkeyUpdateTriggerAtom } from '@/src/stores/hotkeys/atoms'

/**
 * Hook to listen for hotkey generation events and trigger a refresh of hotkey atoms
 */
export function useHotkeyGeneratedListener() {
  // Using useAtom instead of useSetAtom ensures the getter is mounted and allows other hooks to react to changes
  const [, setHotkeyUpdateTrigger] = useAtom(hotkeyUpdateTriggerAtom)

  useEffect(() => {
    const handleHotkeyGenerated = () => {
      setHotkeyUpdateTrigger((prev) => prev + 1)
    }

    window.addEventListener(HotkeyGeneratedEvent, handleHotkeyGenerated)
    return () => {
      window.removeEventListener(HotkeyGeneratedEvent, handleHotkeyGenerated)
    }
  }, [setHotkeyUpdateTrigger])
}
